import React, { useEffect } from 'react'
import './header.css'
import { Link } from 'react-router-dom'

function Header() {
    /* 좌측하단 폴더 svg 2개 겹치기 */
    const gnbFolder = {background: 'url("./svg/folder.svg") no-repeat center', backgroundSize:'cover'}
    const gnbFile = {background: 'url("./svg/folder__file.svg") no-repeat center', backgroundSize:'cover'}

    /* useEffct Hook */
    useEffect(()=>{
        // 시간 구하기
        const diskTime = document.querySelector('.disk_time');
        // 현재 시간, 분 구하기 = Date() 사용하여 동적값 할당
        const nowHour = document.querySelector('.time_nowHour');
        const nowMinute = document.querySelector('.time_nowMinute');
        // 현재 시간관련 변수
        let today;
        let hh;
        let mm; 
        // 상단 카세트 옆 숫자
        let recordTime = 98;
        
        setInterval(function(){
            if(recordTime>1){ //초깃값 98이 있으면
                diskTime.innerHTML = recordTime-1;
            }else{
                diskTime.innerHTML = `99`;
                recordTime = 98;
            }
        },1000*60); // 1분마다 새로고침

        /* 현재 시간 구하기 */
        setInterval(function(){
            today = new Date();
            hh = (today.getHours()<10?'0'+today.getHours():today.getHours()); // 1시~9시 앞에 0붙이기
            mm = (today.getMinutes()<10?'0'+today.getMinutes():today.getMinutes()); // 1시~9시 앞에 0붙이기
            nowHour.innerHTML = hh;
            nowMinute.innerHTML = (hh<12?`${mm} AM`:`${mm} PM`);
        },1000);



    },[]) // end of useEffect

/* 화면 */
    return (
        <>
            <aside>
                {/* 좌측 상단 W T */}
                <div className='camera_scroll'>
                    <span>W</span>
                    <div className='scroll_box'><span className='scroll_bar'></span></div>
                    <span>T</span>
                </div>
                {/* 우측 상단 */}
                {/* 배터리, 플레이 아이콘 */}
                <div className='camera_info'>
                    <div className='info_icon'>
                        <img src="./svg/battery.svg" alt="battery" className='svg info_battery' />
                        <img src="./svg/play.svg" alt="recording" className='svg info_play' />
                    </div>
                    {/* 랜덤 시계 */}
                    <div className='info_recordTime'>
                        <span className='random_time'></span>:<span className='random_time'></span>:<span className='random_time'></span>
                    </div>
                    {/* 카세트 아이콘 99 min */}
                    <div className='info_capacity'>
                        <img src="./svg/record.svg" alt="disk capacity" className='svg info_disk' />
                        <span className='disk_text'><span className='disk_time'>99</span>min</span>
                    </div>
                </div>

                {/* 우측하단 현재시간 */}
                <div className='camera_time'>
                    <span className='time_nowHour'>00</span>
                    <span className='colon_blank'>:</span>
                    <span className='time_nowMinute'>00 AM</span>
                </div>
            </aside>
            {/* 하단 gnb 메뉴 */}
            <header>
                <input type="checkbox" id='gnbBtn' />
                <ul className='gnb'>
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/trailer">Trailer</Link></li>
                    <li><Link to="/characters">Characters</Link></li>
                    <li><Link to="/synopsis">Synopsis</Link></li>
                    <li><a href="https://www.disneyplus.com/ko-kr/home" target="_blank" rel="noreferrer">Disney+</a></li>
                </ul>

                {/* 하단 버튼 이미지 */}
                <button type='button'>
                    <label htmlFor='gnbBtn'>
                        <div className='folder' style={gnbFolder}>
                            <div className='file' style={gnbFile}>
                                메뉴
                            </div>
                        </div>
                    </label>
                </button>
            </header>
        </>
    )
}

export default Header